import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IdentitableButtonEnum } from '../desktop/subscription-table-desktop.component';
import { PlanFeatureService } from 'src/app/services/common/plan-feature.service';

@Component({
  selector: 'app-subscription-table-mobile',
  templateUrl: './subscription-table-mobile.component.html',
  styleUrls: ['./subscription-table-mobile.component.scss']
})
export class SubscriptionTableMobileComponent {
  @Input() identibasePlusButtonLabel: string;
  @Input() identialertButtonLabel: string;
  @Input() identifindButtonLabel: string;

  @Input() basicPlusHighlighted: boolean;
  @Input() alertHighlighted: boolean;
  @Input() findHighlighted: boolean;
  @Input() buyButtonVisible: boolean;
  @Input() buyButtonDisabled: boolean;

  @Output() identitableButtonClicked: EventEmitter<string> = new EventEmitter();
  constructor(
    public planFeatureService: PlanFeatureService
  ) {}

  public IdentitableButtonEnum = IdentitableButtonEnum;
  
  getFeaturesFor(plan: string): any[] {
    return this.planFeatureService.getFeaturesFor(plan);
  }

  public onIdentitableButtonClicked(buttonClicked: string) {
    this.identitableButtonClicked.emit(buttonClicked);
  }

}
